import React, { useState, useEffect } from "react";
import "./index.css";
import Phone from "../../../../../assets/images/phone.png";
import { Table, Tag, Empty } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  PhoneOutlined,
  CarOutlined,
} from "@ant-design/icons";
import { BsThreeDotsVertical } from "react-icons/bs";
import axios from "axios";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import { toast } from "react-toastify";
import Result from "./Result";
import moment from "moment";
import { LiaGreaterThanSolid } from "react-icons/lia";
import EvacModal1 from "./modals";
import SuccessModal from "./modals/success";
import { Spinner } from "react-bootstrap";
import EvacModal2 from "./modals/capture";
import EvacDetailsModal from "./modals/details";
import capitalize from "../../../../../capitalize";
import { storage } from "../../../../../scopedStorage";

// The evacuation-request endpoint is a single call that needs the weights, so
// Step 1 (driver details) no longer hits the API. It is persisted locally and
// the whole thing is submitted from Step 2. The draft is keyed per center so a
// reload/crash resumes at the exact step the user left off.
const evacDraftKey = () => {
  let id = "";
  try {
    id = JSON.parse(storage.getItem("centerInfo"))?.id || "";
  } catch (e) {
    id = "";
  }
  return `switch_evac_draft_aggregation_${id}`;
};

const readEvacDraft = () => {
  try {
    return JSON.parse(localStorage.getItem(evacDraftKey())) || null;
  } catch (e) {
    return null;
  }
};

const writeEvacDraft = (draft) => {
  try {
    localStorage.setItem(evacDraftKey(), JSON.stringify(draft));
  } catch (e) {
    /* ignore quota / private mode errors */
  }
};

const clearEvacDraft = () => {
  try {
    localStorage.removeItem(evacDraftKey());
  } catch (e) {
    /* ignore */
  }
};

const EvacuationRequest = ({ setTitleName }) => {
  const initialDraft = readEvacDraft();

  const [historyData, setHistoryData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [code, setCode] = useState("");
  const [driverName, setDriverName] = useState(initialDraft?.driverName || "");
  const [driverPhone, setDriverPhone] = useState(initialDraft?.driverPhone || "");
  const [plateNo, setPlateNo] = useState(initialDraft?.plateNo || "");
  const [nylon, setNylon] = useState(initialDraft?.nylon || "");
  const [pet, setPet] = useState(initialDraft?.pet || "");
  const [products, setProducts] = useState([]);
  const [groupWeights, setGroupWeights] = useState(initialDraft?.groupWeights || {});
  const [shortLabels, setShortLabels] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(
    initialDraft?.selectedCategories || []
  );
  const [ProcessedEvacuation, setProcessedEvacuation] = useState([]);

  const [draft, setDraft] = useState(initialDraft);
  const [flowActive, setFlowActive] = useState(false);
  const [flowStep, setFlowStep] = useState(initialDraft?.step || 1);

  // Persist every keystroke while a flow is active so a reload resumes exactly
  // where the user stopped, at either step.
  useEffect(() => {
    if (!flowActive) return;
    const hasContent =
      driverName ||
      driverPhone ||
      plateNo ||
      nylon ||
      pet ||
      selectedCategories.length;
    if (!hasContent) return;
    const next = {
      step: flowStep,
      driverName,
      driverPhone,
      plateNo,
      selectedCategories,
      groupWeights,
      nylon,
      pet,
    };
    writeEvacDraft(next);
    setDraft(next);
  }, [
    flowActive,
    flowStep,
    driverName,
    driverPhone,
    plateNo,
    selectedCategories,
    nylon,
    pet,
  ]);

  const resetEvacFields = () => {
    setDriverName("");
    setDriverPhone("");
    setPlateNo("");
    setSelectedCategories([]);
    setNylon("");
    setPet("");
  };

  const discardDraft = () => {
    clearEvacDraft();
    setDraft(null);
    setFlowActive(false);
    setFlowStep(1);
    resetEvacFields();
  };

  const resumeDraft = () => {
    const d = draft || {};
    setDriverName(d.driverName || "");
    setDriverPhone(d.driverPhone || "");
    setPlateNo(d.plateNo || "");
    setSelectedCategories(d.selectedCategories || []);
    setNylon(d.nylon || "");
    setPet(d.pet || "");
    setFlowActive(true);
    setFlowStep(d.step || 1);
    if ((d.step || 1) === 2) {
      handleShowEvac2();
    } else {
      handleShowEvac1();
    }
  };

  const startInitiation = () => {
    setFlowActive(true);
    setFlowStep(1);
    handleShowEvac1();
  };

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
    showSizeChanger: false,
  });

  const handleTableChange = (newPagination) => {
    getHistory(newPagination.current, newPagination.pageSize);
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  const [showEvac1, setShowEvac1] = useState(false);
  const handleCloseEvac1 = () => setShowEvac1(false);
  const handleShowEvac1 = () => setShowEvac1(true);

  const [showEvac2, setShowEvac2] = useState(false);
  const handleCloseEvac2 = () => setShowEvac2(false);
  const handleShowEvac2 = () => setShowEvac2(true);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  const handleShowSuccessModal = () => setShowSuccessModal(true);

  const [showDetails, setShowDetails] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const handleCloseDetails = () => setShowDetails(false);
  const handleShowDetails = (record) => {
    setSelectedRecord(record);
    setShowDetails(true);
  };

  const safeAddAndFormat = (a, b) => {
    const numA = Number(a) || 0;
    const numB = Number(b) || 0;
    const total = numA + numB;
    return `${total.toFixed(3)}`;
  };

  const statusTagColor = (status) => {
    switch ((status || "").toLowerCase()) {
      case "completed":
        return "green";
      case "processing":
        return "blue";
      case "cancelled":
      case "rejected":
        return "red";
      default:
        return "gold";
    }
  };

  const columns = [
    {
      title: "SN",
      dataIndex: "key",
      key: "id",
      sorter: false,
      render: (id, record, index) => {
        ++index;
        return index;
      },
    },
    {
      title: "Weight",
      dataIndex: "",
      key: "",
      render: (text) => (
        // <p className="mb-0" style={{ fontSize: "13px" }}>{`${text?.nylon_kg || text?.pet_plastic_kg && safeAddAndFormat(
        //   text?.nylon_kg,
        //   text?.pet_plastic_kg
        // )(text?.nylon_kg, text?.pet_plastic_kg)}kg`}</p>
        <p className="mb-0" style={{ fontSize: "13px" }}>
          {text?.total_evacuated_kg}
        </p>
      ),
    },
    {
      title: "Driver",
      dataIndex: "driver_name",
      key: "driver_name",
      render: (driver) => {
        return (
          <p className="mb-0" style={{ fontSize: "13px" }}>
            {driver}
          </p>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <p>{moment(created_at).format("DD/MM/YYYY")}</p>,
    },
    {
      title: "Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <p>{moment(created_at).format("HH:mm")}</p>,
    },
    {
      title: "Vehicle No",
      dataIndex: "vehicle_plate_no",
      key: "vehicle_plate_no",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={statusTagColor(status)} className="evacStatusTag">
          {capitalize(status)}
        </Tag>
      ),
    },

    {
      title: " ",
      key: "action",
      width: 50,
      align: "center",
      render: (_, record) => (
        <BsThreeDotsVertical
          className="evacHistoryAction"
          onClick={() => handleShowDetails(record)}
        />
      ),
    },
  ];

  const captureEvacuation = () => {
    if (!driverName) {
      toast.error("Driver's Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (driverName.length < 3) {
      toast.error("Driver's Name must be at least 3 characters", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!driverPhone) {
      toast.error("Driver's Phone is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (driverPhone.length < 11) {
      toast.error("Driver's Phone must be 11 characters", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!plateNo) {
      toast.error("Vehicle Plate No is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    // if (selectedCategories.length === 0) {
    //   toast.error("A minimum of 1 category is required", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     pauseOnHover: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }
    // if (selectedCategories.includes("Nylon") && (!nylon || nylon <= 0)) {
    //   toast.error("Nylon kg is required", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     pauseOnHover: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }

    // if (selectedCategories.includes("PET Plastics") && (!pet || pet <= 0)) {
    //   toast.error("PET Plastics kg is required", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     pauseOnHover: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }
    ProcessEvacuation();
  };

  const captureEvacuationRequest = () => {
    if (!driverName) {
      toast.error("Driver's Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (driverName.length < 3) {
      toast.error("Driver's Name must be at least 3 characters", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!driverPhone) {
      toast.error("Driver's Phone is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (driverPhone.length < 11) {
      toast.error("Driver's Phone must be 11 characters", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!plateNo) {
      toast.error("Vehicle Plate No is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (selectedCategories.length === 0) {
      toast.error("A minimum of 1 category is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (selectedCategories.includes("Nylon") && (!nylon || nylon <= 0)) {
      toast.error("Nylon kg is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    if (selectedCategories.includes("PET Plastics") && (!pet || pet <= 0)) {
      toast.error("PET Plastics kg is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    ProcessEvacuationRequest();
  };

  // Step 1: no API call. Persist the driver details locally and move to the
  // capture step, which submits driver + categories + weights in one request.
  const ProcessEvacuation = () => {
    const next = {
      step: 2,
      driverName,
      driverPhone,
      plateNo,
      selectedCategories,
      groupWeights,
      nylon,
      pet,
    };
    writeEvacDraft(next);
    setDraft(next);
    setFlowActive(true);
    setFlowStep(2);
    handleCloseEvac1();
    handleShowEvac2();
  };

  useEffect(() => {
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/waste-products`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setProducts(res?.data?.data ?? res?.data ?? []))
      .catch(() => setProducts([]));
  }, []);

  const setGroupWeight = (label, value) => {
    setGroupWeights((prev) => ({ ...prev, [label]: value }));
    setShortLabels([]);
  };

  const ProcessEvacuationRequest = () => {
    // console.log(driverName)
    const groups = selectedCategories
      .map((label) => ({ label, weight: parseFloat(groupWeights[label]) }))
      .filter((g) => !isNaN(g.weight) && g.weight > 0);

    if (groups.length === 0) {
      toast.error("Enter a weight for each product being evacuated");
      return;
    }

    const payload = {
      driver_name: driverName,
      driver_phone: driverPhone,
      vehicle_plate_no: plateNo,
      groups,
    };
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .post(
        `${switchEndpoint}/aggregation-center/evacuation-request`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setProcessedEvacuation(response.data.data);
        setCode(response.data.data?.code);
        clearEvacDraft();
        setDraft(null);
        setFlowActive(false);
        setFlowStep(1);
        handleCloseEvac2();
        handleShowSuccessModal();
        getPending();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const short = error.response?.data?.errors?.short;
        setShortLabels(Array.isArray(short) ? short : []);
        toast.error(error.response?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getPending = () => {
    setLoading1(true);
    const token = storage.getItem("token");
    axios
      .get(
        `${switchEndpoint}/aggregation-center/evacuation-requests-history?status=pending`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setPendingData(response.data.data.data);
        // console.log(response.data.data.data)
        setLoading1(false);
      })
      .catch((error) => {
        setLoading1(false);
        toast.error(error.response, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getHistory = (page, pageSize) => {
    const token = storage.getItem("token");

    axios
      .get(
        `${switchEndpoint}/aggregation-center/evacuation-requests-history?status=completed&page=${page}&pageSize=${pageSize}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setHistoryData(response.data.data.data);

        setPagination((prev) => ({
          ...prev,
          total: response.data.data.meta.total,
          current: page,
        }));
      })
      .catch((error) => {
        toast.error(error.response, {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
      });
  };


  useEffect(() => {
    setTitleName("Evacuation Requests");
    getHistory(pagination.current, pagination.pageSize);
    getPending();
  }, []);

  return (
    <main>
      <div className="main__container">
        <div className="separatingDivs">
          <div>
            {loading1 ? (
              <div className="text-center mt-3">
                <div className="" style={{ margin: "0 auto" }}>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </div>
              </div>
            ) : (
              <>
                {draft ? (
                  <div className="evacCard cardsss py-4">
                    <div className="cards_extra">
                      <div className="card_inners_amount"></div>
                      <div className="card_inners text-left">
                        <p
                          style={{
                            fontWeight: "600",
                            color: "#000",
                            fontSize: "14px",
                            marginLeft: "5px",
                          }}
                        >
                          {`Evacuation Request In Progress — Step ${
                            draft.step || 1
                          } of 2`}
                        </p>
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#404040",
                            marginLeft: "5px",
                          }}
                        >
                          {draft.driverName
                            ? `Driver: ${draft.driverName}`
                            : "Not submitted yet"}
                        </p>
                        <div>
                          <div className="d-flex align-items-center">
                            <div style={{ width: "50%" }} className="">
                              <button
                                style={{ fontSize: "13px" }}
                                type="button"
                                className="btn loginBtn btn-sm btn-block"
                                onClick={() => {
                                  resumeDraft();
                                }}
                              >
                                {`Resume ${
                                  (draft.step || 1) === 2
                                    ? "Capture"
                                    : "Initiation"
                                }`}
                              </button>
                            </div>
                            <div className="ml-3">
                              <button
                                type="button"
                                className="btn btn-sm p-0"
                                style={{
                                  fontSize: "12px",
                                  color: "#c0392b",
                                  textDecoration: "underline",
                                  background: "none",
                                  border: "none",
                                }}
                                onClick={() => {
                                  discardDraft();
                                }}
                              >
                                Discard
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : pendingData.length > 0 ? (
                  <div className="evacCard cardsss py-4">
                    <div className="cards_extra">
                      <div className="card_inners_amount"></div>
                      <div className="card_inners text-left">
                        <p
                          style={{
                            fontWeight: "600",
                            color: "#000",
                            fontSize: "14px",
                            marginLeft: "5px",
                          }}
                        >
                          Evacuation Captured &mdash; Awaiting Factory Processing
                        </p>
                        {pendingData[0]?.code && (
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#404040",
                              marginLeft: "5px",
                            }}
                          >
                            Evacuation Code: <b>{pendingData[0].code}</b>
                          </p>
                        )}
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#898989",
                            marginLeft: "5px",
                          }}
                        >
                          You can start a new evacuation once the factory has
                          processed this one.
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <div className="card_inners d-flex align-items-center">
                        <div className="" style={{ cursor: "pointer" }}>
                          <p className="mb-0">
                            Message Evacuation Driver
                            <span
                              className="pl-2 mb-0 mr-5"
                              style={{ color: "#cbde1f", fontSize: "15px" }}
                            >
                              <LiaGreaterThanSolid />
                            </span>{" "}
                          </p>
                        </div>
                        <div className="d-flex align-items-center">
                          <img src={Phone} alt="phone" />
                          <p
                            className="mb-0 ml-2"
                            style={{ fontSize: "14px", color: "#898989" }}
                          >
                            {pendingData[0]?.driver_phone}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="evacCard cardsss py-4">
                    <div className="cards_extra">
                      <div className="card_inners_amount"></div>
                      {loading1 ? (
                        <div className="text-center mt-3">
                          <div className="" style={{ margin: "0 auto" }}>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="card_inners text-left">
                          <p
                            style={{
                              fontWeight: "600",
                              color: "#000",
                              fontSize: "14px",
                              marginLeft: "5px",
                            }}
                          >
                            Evacuation Request
                          </p>
                          <div>
                            <div className="d-flex align-items-center">
                              <div style={{ width: "50%" }} className="">
                                <button
                                  style={{ fontSize: "13px" }}
                                  type="button"
                                  className="btn loginBtn btn-sm btn-block"
                                  onClick={() => {
                                    startInitiation();
                                  }}
                                >
                                  Initiate Evacuation Request
                                </button>
                              </div>
                              {/* <div
                                className="ml-3"
                                style={{ cursor: "pointer" }}
                              >
                                <p className="mb-0">
                                  Message Evacuation Driver
                                  <span
                                    className="pl-2 mb-0 mr-2"
                                    style={{
                                      color: "#cbde1f",
                                      fontSize: "15px",
                                    }}
                                  >
                                    <LiaGreaterThanSolid />
                                  </span>{" "}
                                </p>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* <div className="">
                      <div className="card_inners d-flex justify-content-between align-items-center">
                        <div className="" />
                        <div className="d-flex align-items-center mr-5">
                          <img src={Phone} alt="phone" />
                          <p
                            className="mb-0 ml-2"
                            style={{ fontSize: "14px", color: "#898989" }}
                          >
                            09088990099
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                )}
              </>
            )}
          </div>

          <div className="requestss">
            <div className="cardss">
              <div className="mb-2">
                <h4 className="dropOff__title mt-1 mr-4 mb-2">
                  <b>Scheduled Evacuation</b> ({pendingData?.length})
                </h4>
              </div>
              {pendingData.length === 0 ? (
                <Empty
                  description="No scheduled evacuation requests"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  className="evacEmptyState"
                />
              ) : (
                pendingData.map((pending) => {
                  const groups = Array.isArray(pending?.evacuation_groups)
                    ? pending.evacuation_groups
                    : null;
                  const totalKg =
                    pending?.total_requested_kg !== undefined
                      ? `${pending.total_requested_kg}`
                      : safeAddAndFormat(pending?.nylon_kg, pending?.pet_plastic_kg);

                  return (
                    <div
                      className="evacPendingCard"
                      key={pending?.id || pending?.code}
                    >
                      <div className="evacPendingCard__top">
                        <div>
                          <span className="evacPendingCard__label">
                            Total Requested
                          </span>
                          <div className="evacPendingCard__weight">
                            {totalKg}
                            <span>kg</span>
                          </div>
                          {pending?.code && (
                            <p className="evacPendingCard__code">
                              Code: <b>{pending.code}</b>
                            </p>
                          )}
                        </div>
                        <Tag
                          color={statusTagColor(pending?.status || "pending")}
                          className="evacStatusTag"
                        >
                          {capitalize(pending?.status || "pending")}
                        </Tag>
                      </div>

                      <div className="evacPendingCard__meta">
                        <div className="evacPendingCard__metaItem">
                          <CalendarOutlined />
                          <div>
                            <span>Date &amp; Time</span>
                            <p>
                              {moment(pending?.created_at).format(
                                "DD MMM YYYY, HH:mm"
                              )}
                            </p>
                          </div>
                        </div>

                        <div className="evacPendingCard__metaItem">
                          <UserOutlined />
                          <div>
                            <span>Driver</span>
                            <p>{pending?.driver_name || "—"}</p>
                          </div>
                        </div>

                        <div className="evacPendingCard__metaItem">
                          <PhoneOutlined />
                          <div>
                            <span>Phone</span>
                            <p>{pending?.driver_phone || "—"}</p>
                          </div>
                        </div>

                        <div className="evacPendingCard__metaItem">
                          <CarOutlined />
                          <div>
                            <span>Vehicle No</span>
                            <p>{pending?.vehicle_plate_no || "—"}</p>
                          </div>
                        </div>
                      </div>

                      {groups && groups.length > 0 && (
                        <div className="evacGroupChips">
                          {groups.map((g) => (
                            <span className="evacGroupChip" key={g.label}>
                              {g.name || g.label}:{" "}
                              <b>{Number(g.requested_kg) || 0}kg</b>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>

          <div className="requestss">
            <div className="cardss p-0 py-1 px-2">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <span className="d-flex align-items-center py-3 px-2">
                    <b>History </b>({historyData?.length})
                  </span>
                </div>
                <div className="fpw mr-2">
                  <p style={{ color: "#231F20", fontSize: "13px" }}>
                    Filter By
                    <span style={{ color: "#c4da00", marginLeft: "5px" }}>
                      &#62;
                    </span>
                  </p>
                </div>
              </div>

              <Table
                columns={columns}
                dataSource={historyData}
                size="middle"
                rowKey="id"
                pagination={pagination}
                onChange={handleTableChange}
              />

            </div>
          </div>
        </div>
      </div>

      <EvacModal1
        showEvac1={showEvac1}
        handleCloseEvac1={handleCloseEvac1}
        driverName={driverName}
        setDriverName={setDriverName}
        driverPhone={driverPhone}
        setDriverPhone={setDriverPhone}
        plateNo={plateNo}
        setPlateNo={setPlateNo}
        nylon={nylon}
        setNylon={setNylon}
        pet={pet}
        setPet={setPet}
        captureEvacuation={captureEvacuation}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        loading={loading}
      />

      <EvacModal2
        showEvac2={showEvac2}
        handleCloseEvac2={handleCloseEvac2}
        driverName={driverName}
        setDriverName={setDriverName}
        driverPhone={driverPhone}
        setDriverPhone={setDriverPhone}
        plateNo={plateNo}
        setPlateNo={setPlateNo}
        nylon={nylon}
        setNylon={setNylon}
        pet={pet}
        setPet={setPet}
        captureEvacuation={captureEvacuation}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        products={products}
        groupWeights={groupWeights}
        setGroupWeight={setGroupWeight}
        shortLabels={shortLabels}
        loading={loading}
        pendingData={pendingData}
        captureEvacuationRequest={captureEvacuationRequest}
        code={code || pendingData?.[0]?.code}
      />

      <SuccessModal
        showSuccessModal={showSuccessModal}
        handleCloseSuccessModal={handleCloseSuccessModal}
        ProcessedEvacuation={ProcessedEvacuation}
        code={code}
      />

      <EvacDetailsModal
        showDetails={showDetails}
        handleCloseDetails={handleCloseDetails}
        record={selectedRecord}
      />
    </main>
  );
};

export default EvacuationRequest;
